import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { ReportService } from '../../../core/services/report.service';

@Component({
  selector: 'app-jasper-reports',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSnackBarModule
  ],
  templateUrl: './jasper-reports.component.html',
  styleUrls: ['./jasper-reports.component.scss']
})
export class JasperReportsComponent implements OnInit {
  reportForm: FormGroup;
  isLoading = false;
  selectedReportType: string = 'ComplaintsSummary';

  reportTypes = [
    { value: 'JobCardReportMesFS', label: 'Job Card Report MesFS' },
    { value: 'rptJobcardplain', label: 'Job Card Plain' },
    { value: 'CountSummaryGE', label: 'Complaints Summary' },
    { value: 'ComplaintsZones', label: 'Complaints by Zones' },
    { value: 'JobCard_EmpWise', label: 'Job Card - Employee Wise' },
    { value: 'JobCard_Location', label: 'Job Card - Location Wise' },
    { value: 'LocationReport', label: 'Location Report' },
    { value: 'UserLogin', label: 'User Login Report' },
    { value: 'UserRegistration', label: 'User Registration Report' },
    { value: 'SurveyReport', label: 'Survey Report' }
  ];

  constructor(
    private formBuilder: FormBuilder,
    private reportService: ReportService,
    private snackBar: MatSnackBar
  ) {
    this.reportForm = this.formBuilder.group({
      reportType: [this.selectedReportType, Validators.required],
      startDate: [null],
      endDate: [null]
    });
  }

  ngOnInit(): void {
    this.reportForm.valueChanges.subscribe(value => {
      this.selectedReportType = value.reportType;
    });
  }

  onReportTypeChange(reportType: string): void {
    this.selectedReportType = reportType;
    this.reportForm.patchValue({ reportType });
  }

  generateReport(): void {
    if (this.reportForm.invalid) {
      this.snackBar.open('Please select a report type', 'Close', { duration: 3000 });
      return;
    }

    this.isLoading = true;
    const reportName = this.reportForm.get('reportType')?.value;
    const startDate = this.reportForm.get('startDate')?.value;
    const endDate = this.reportForm.get('endDate')?.value;

    const params: any = {};
    if (startDate) {
      params.startDate = this.formatDate(startDate);
    }
    if (endDate) {
      params.endDate = this.formatDate(endDate);
    }

    this.reportService.downloadReport(reportName, params).subscribe(
      (response: any) => {
        this.isLoading = false;
        this.downloadPDF(response, reportName);
        this.snackBar.open('Report generated successfully', 'Close', { duration: 3000 });
      },
      (error: any) => {
        this.isLoading = false;
        console.error('Error generating report:', error);
        this.snackBar.open('Error generating report. Please try again.', 'Close', { duration: 3000 });
      }
    );
  }

  private downloadPDF(blob: any, reportName: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${reportName}_${new Date().getTime()}.pdf`;
    link.click();
    window.URL.revokeObjectURL(url);
  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  clearForm(): void {
    this.reportForm.reset({ reportType: this.selectedReportType });
  }
}

